import { render } from "./Leaderboard.vue?vue&type=template&id=5e2b6e5a"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"

import "./Leaderboard.vue?vue&type=style&index=0&id=5e2b6e5a&lang=scss"
script.render = render

export default script